import { render, staticRenderFns } from "./StudioLessonDetail.vue?vue&type=template&id=4825d89c&scoped=true&"
import script from "./StudioLessonDetail.vue?vue&type=script&lang=js&"
export * from "./StudioLessonDetail.vue?vue&type=script&lang=js&"
import style0 from "./StudioLessonDetail.vue?vue&type=style&index=0&id=4825d89c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4825d89c",
  null
  
)

export default component.exports